
import React, {Component} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import isNumber from 'lodash/isNumber'

import * as actions from '../../../actionTypes'
import {FACTOR_EFFECTS} from '../../../constants'
import FactorEffectSlider from './FactorEffectSlider'
import FormHeader from '../FormHeader'


class FactorEffectContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      currentFactor: null,
      indexToUpdate: null
    }
    this.amendNavigation()
    this.initFactorEffects()
  }

  // Display factors in typed order not importance order
  static getDerivedStateFromProps(nextProps, prevState){
    const { navigator, effectWeightedFactors, topFactorsInTypedOrder } = nextProps
    let currentFactor
    let indexToUpdate

    effectWeightedFactors.forEach((factor, index) => {
      if (factor.text === topFactorsInTypedOrder[navigator.cdi]) {
        currentFactor = factor
        indexToUpdate = index
      }
    })

    return {
      currentFactor,
      indexToUpdate
    }
  }

  amendNavigation() {
    const back = () => this.props.navigator.cdi === 0
    const forward = () => this.props.topFactors.length - 1 === this.props.navigator.cdi
    this.props.navigator.amendNavigation({back, forward})
  }

  componentDidUpdate(prevProps) {
    const {navigator} = this.props
    if(isNumber(navigator.cdi) && prevProps.navigator.cdi !== navigator.cdi) {
      // Needed due to skipping top 3 factors page
      // cdi update happens in background and
      // need to change ammend based on that when complete
      this.amendNavigation()
      this.handleCdiChange()
    }
  }

  handleCdiChange() {
    if (this.props.effectWeightedFactors.length) {
      const weight = this.props.effectWeightedFactors[this.props.navigator.cdi].weight
      this.updateNavigation(weight)
    }
  }

  handleSliderChange(weight) {
    const { resetFinalWeight, updateEffectWeight } = this.props
    resetFinalWeight()
    updateEffectWeight(this.state.indexToUpdate, weight)
    this.updateNavigation(weight)
  }

  initEffectWeightedFactors() {
    const {effectWeightedFactors, setEffectWeightedFactors, topFactors} = this.props

    if(!effectWeightedFactors.length) {
      const effectWeightedFactors = topFactors.map(text => (
        {text, weight: FACTOR_EFFECTS.uninitializedWeight})
      )
      setEffectWeightedFactors(effectWeightedFactors)
    }
  }

  initFactorEffects() {
    const {navigator: {cdi}} = this.props
    this.initEffectWeightedFactors()
    if(isNumber(cdi)) {
      this.handleCdiChange()
    }
  }

  updateNavigation(effectWeight) {
    const {navigator} = this.props
    if(effectWeight) {
      navigator.enableForward()
    } else {
      navigator.disableForward()
    }
  }

  getFormDescription(factorText,factors1,factorOptions,t) {
    if(factors1.includes(factorText)) {
      return t('How Much Support', {OPTIONNUM1: 1, OPTIONTEXT1: factorOptions[0], OPTIONNUM2: 2, OPTIONTEXT2: factorOptions[1]})
    } else {
      return t('How Much Support', {OPTIONNUM1: 2, OPTIONTEXT1: factorOptions[1], OPTIONNUM2: 1, OPTIONTEXT2: factorOptions[0]})
    }
  }

  render() {
    const { factors1, factorOptions, isCounselingSessionDisabled, navigator, t } = this.props
    const { currentFactor } = this.state

    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={8}
      >
      {currentFactor && (
        <React.Fragment>
          <FormHeader
            description={this.getFormDescription(currentFactor.text,factors1,factorOptions,t)}
            stepNumber={t(`Step ${navigator.getStepNumber()}`)}
          />
        <Grid item xs={8}>
            <FactorEffectSlider
              disabled={isCounselingSessionDisabled}
              label={currentFactor.text}
              key={navigator.cdi}
              onChange={weight => this.handleSliderChange(weight)}
              weight={currentFactor.weight}
            />
          </Grid>
        </React.Fragment>
      )}
      </Grid>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  resetFinalWeight() {
    const action = {type: actions.RESET_FINAL_WEIGHT}
    dispatch(action)
  },
  setEffectWeightedFactors(effectWeightedFactors) {
    const action = {type: actions.SET_EFFECT_WEIGHTED_FACTORS, payload: {effectWeightedFactors}}
    dispatch(action)
  },
  updateEffectWeight(index, weight) {
    const action = {type: actions.FACTOR_EFFECT_UPDATE_WEIGHT, payload: {index, weight}}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  topFactors: state.counselingSession.counselingSessionData.topThreeFactors,
  factors1: state.counselingSession.counselingSessionData.factorsOption1,
  factorOptions: state.counselingSession.counselingSessionData.options,
  effectWeightedFactors: state.counselingSession.counselingSessionData.topThreeFactorsWithAffectWeights,
  topFactorsInTypedOrder: state.counselingSession.counselingSessionData.factorsOption1
    .concat(state.counselingSession.counselingSessionData.factorsOption2)
    .filter(ele => state.counselingSession.counselingSessionData.topThreeFactors.indexOf(ele) !== -1)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(FactorEffectContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/factor-effect/FactorEffectContainer.js